import { Item } from "../interfaces";
import ItemTerm, { TermProps } from "./item-term";
import ItemImage from "./item-image";

export interface ItemContentProps extends TermProps {
  item: Item;
}

const ItemContent = (props: ItemContentProps) => {
  const { getBEMBlocksWith, item, ...restProps } = props;

  return (
    <>
      <ItemImage image={item.image} className={getBEMBlocksWith("__image")} />
      <div>
        <div className={getBEMBlocksWith("__content")}>
          <ItemTerm
            item={item}
            getBEMBlocksWith={getBEMBlocksWith}
            {...restProps}
          />
        </div>
        {item.description && (
          <div className={getBEMBlocksWith("__content-description")}>
            {item.description}
          </div>
        )}
      </div>
    </>
  );
};

ItemContent.displayName = "ItemContent";

export default ItemContent;
